"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMouseEventTypeNames = exports.EMouseEventType = void 0;
/**
 * @public
 * Supported mouse event types, most events are handled through {@link EPointerEventType}.
 */
var EMouseEventType;
(function (EMouseEventType) {
    EMouseEventType[EMouseEventType["Wheel"] = 0] = "Wheel";
})(EMouseEventType = exports.EMouseEventType || (exports.EMouseEventType = {}));
/**
 * @internal
 */
class EMouseEventTypeNames {
}
exports.EMouseEventTypeNames = EMouseEventTypeNames;
_a = EMouseEventType.Wheel;
EMouseEventTypeNames[_a] = "Wheel";
//# sourceMappingURL=e-mouse-event-type.js.map